export const environment = {
    apiUrl: "https://admin.focusedon-st.ai/apigateway/",
    // Firebase
    firebaseConfig: {
        apiKey: "AIzaSyBuif9YvCItTKgtZdqdOhvUQiZAg9JeqKQ",
        authDomain: "admin-mdsw-st.firebaseapp.com",
        projectId: "admin-mdsw-st",
        storageBucket: "admin-mdsw-st.firebasestorage.app",
        messagingSenderId: "957118909809",
        appId: "1:957118909809:web:a5a1b099f7094db2cbfad0"
    },
};